__webpack_require__.p = "/magazyn/projekty-2025/";